<template>
    <service-ticket-details-dialog :ticketId="ticketToEdit"
                                   :visible="dialogVisible"
                                   @dialogClosed="editFinished"></service-ticket-details-dialog>
</template>

<script>

 import ServiceTicketDetailsDialog from "./ServiceTicketDetailsDialog";
 import api from "../api";

export default {
        name: "service-ticket-list-from-email",
        components: {
            ServiceTicketDetailsDialog
        },
        data() {
            return {
                dialogVisible: false,
                ticketToEdit: this.$route.params.ticketId
            };
        },
        created() {
            api
                .updateEmailStatus(
                    this.ticketToEdit
                );
        },
        mounted() {
            if (this.ticketToEdit) {
                this.editTicket(parseInt(this.ticketToEdit));
            }
        },
        methods: {
            editTicket(id) {
                this.ticketToEdit = id;
                this.dialogVisible = true;
            },
            editFinished() {
                this.ticketToEdit = null;
                this.dialogVisible = false;
            }
        }
    };
</script>




// WEBPACK FOOTER //
// ClientApp/app/servicetickets/components/ServiceTicketListFromEmail.vue